import React, { createContext, useContext } from "react";

const FormFieldsMapContext = createContext({});
export const useFormFieldsMap = () => useContext(FormFieldsMapContext);
const FormFieldsProvider = ({ children, value }) => {
  return <FormFieldsMapContext.Provider value={value}>{children}</FormFieldsMapContext.Provider>;
};

export default FormFieldsProvider;
